/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import { GetRequest, GetResultObject, GET_TICKETS, GET_REQUESTED_ORDER, PostRequest} from "../../../utils/API";

const TYPES = {
  REQUEST_TICKET: "REQUEST_TICKET",
  REQUEST_TICKET_SUCCESS: "REQUEST_TICKET_SUCCESS",
  REQUEST_TICKET_FAILED: "REQUEST_TICKET_FAILED",
  UPDATE_TICKET_LIST: "UPDATE_TICKET_LIST",


  REQUEST_REQUESTED_ORDER: "REQUEST_REQUESTED_ORDER",
  REQUEST_REQUESTED_ORDER_SUCCESS: "REQUEST_REQUESTED_ORDER_SUCCESS",
  REMOVE_REQUESTED_ORDER__FROM_LIST: "REMOVE_REQUESTED_ORDER__FROM_LIST",
};


const getTickets = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_TICKET,
      payload: {},
    });

    GetRequest(GET_TICKETS, params).then(result=> {

      GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
        dispatch({
          type: TYPES.REQUEST_TICKET_SUCCESS,
          payload: {data: datas, pages, size, total},
        });
      })
    })
  }
}

const getRequestedOrder = (body, params) => {
  return (dispatch) => {

    dispatch({
      type: TYPES.REQUEST_REQUESTED_ORDER,
      payload: {},
    });

    PostRequest(GET_REQUESTED_ORDER, body, params).then(result=> {

      GetResultObject(result, 'data.content', 200, (datas, {pages, size, total}) => {
        dispatch({
          type: TYPES.REQUEST_REQUESTED_ORDER_SUCCESS,
          payload: {data: datas, pages, size, total},
        });
      })
    })
  }
}

const updateTicketList = ({data}) => {

  return (dispatch) => {
    dispatch({
      type: TYPES.UPDATE_TICKET_LIST,
      payload: {data},
    });
  }
}

const removeTicket = (item) => {
    return (dispatch) => {
      dispatch({
        type: TYPES.REMOVE_REQUESTED_ORDER__FROM_LIST,
        payload: {item},
    });
  }
}
export default {
  getTickets,
  removeTicket,
  updateTicketList,
  getRequestedOrder,
  TYPES,
};
